import axios from 'axios';

export default (params) =>
  axios
    .get(`/v1/announcements?orderBy=created_at&sortedBy=desc`, {
      params,
    })
    .then(({ data }) => data);
